import { service } from '@ember/service';
import Route from '@ember/routing/route';
import classic from 'ember-classic-decorator';

@classic
export default class SiteBillingIndexRoute extends Route {
  @service store;
  @service router;
  @service billingModals;
  @service session;

  model() {
    return this.modelFor('site.billing');
  }

  async beforeModel(transition) {
    const params = transition.to.queryParams;

    if (params.documentId) {
      // Clear session redirect to prevent cross-tab issues
      this.session.set('data.redirect', null);

      try {
        const record = await this.store.queryRecord('polymorphic/billing-item', {
          cursorId: params.documentId,
        });
        this.openDocument(record);
      } catch (err) {
        this.handleQueryDocumentError(err);
      }
    }
  }

  openDocument(document) {
    this.billingModals.showPdf(document);
    this.router.replaceWith('site.billing.index');
  }

  handleQueryDocumentError(err) {
    const errors = err.errors;
    if (errors && errors[0]?.status === '404') {
      this.router.transitionTo('not-found', 'errors/404');
    } else {
      throw err;
    }
  }
}
